import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
/** A URI reference that identifies the problem type */
export var ProblemDetailsType;
(function (ProblemDetailsType) {
    ProblemDetailsType["ABOUT_BLANK"] = "ABOUT_BLANK";
})(ProblemDetailsType || (ProblemDetailsType = {}));
export var PositionState;
(function (PositionState) {
    PositionState["ACTIVE"] = "ACTIVE";
    PositionState["INACTIVE"] = "INACTIVE";
    PositionState["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
})(PositionState || (PositionState = {}));
export var FlightStatus;
(function (FlightStatus) {
    FlightStatus["BEFORE_RUNNING"] = "BEFORE_RUNNING";
    FlightStatus["WAITING_FOR_SCREENSHOT"] = "WAITING_FOR_SCREENSHOT";
    FlightStatus["RUNNING"] = "RUNNING";
    FlightStatus["FINISHED"] = "FINISHED";
})(FlightStatus || (FlightStatus = {}));
export var Invoicing;
(function (Invoicing) {
    Invoicing["NONE"] = "NONE";
    Invoicing["AFTER_RUNTIME"] = "AFTER_RUNTIME";
    Invoicing["START_RUNTIME"] = "START_RUNTIME";
    Invoicing["IMMEDIATELY"] = "IMMEDIATELY";
    Invoicing["CREDIT"] = "CREDIT";
    Invoicing["BY_DELIVERY_500"] = "BY_DELIVERY_500";
    Invoicing["BY_POSITION_END_DATE"] = "BY_POSITION_END_DATE";
    Invoicing["BY_POSITION_END_DATE_MONTH"] = "BY_POSITION_END_DATE_MONTH";
    Invoicing["BY_POSITION_END_DATE_QUARTER"] = "BY_POSITION_END_DATE_QUARTER";
    Invoicing["BY_POSITION_END_DATE_HALFYEAR"] = "BY_POSITION_END_DATE_HALFYEAR";
})(Invoicing || (Invoicing = {}));
export var InvoiceState;
(function (InvoiceState) {
    InvoiceState["NONE"] = "NONE";
    InvoiceState["OPEN"] = "OPEN";
    InvoiceState["CHARGED"] = "CHARGED";
    InvoiceState["PAID"] = "PAID";
    InvoiceState["CANCELED"] = "CANCELED";
    InvoiceState["SPLIT"] = "SPLIT";
    InvoiceState["BAD_DEBT"] = "BAD_DEBT";
    InvoiceState["ARCHIVED"] = "ARCHIVED";
})(InvoiceState || (InvoiceState = {}));
export var TargetingMode;
(function (TargetingMode) {
    TargetingMode["EXCLUDE"] = "EXCLUDE";
    TargetingMode["INCLUDE"] = "INCLUDE";
})(TargetingMode || (TargetingMode = {}));
export var LanguageType;
(function (LanguageType) {
    LanguageType["ALL"] = "ALL";
    LanguageType["DE"] = "DE";
    LanguageType["IT"] = "IT";
    LanguageType["FR"] = "FR";
})(LanguageType || (LanguageType = {}));
export var KeyValuesOperator;
(function (KeyValuesOperator) {
    KeyValuesOperator["AND"] = "AND";
    KeyValuesOperator["OR"] = "OR";
})(KeyValuesOperator || (KeyValuesOperator = {}));
export var OperatorEnum;
(function (OperatorEnum) {
    OperatorEnum["AND"] = "AND";
    OperatorEnum["OR"] = "OR";
})(OperatorEnum || (OperatorEnum = {}));
export var FrequencyPeriod;
(function (FrequencyPeriod) {
    FrequencyPeriod["LIFE_TIME"] = "LIFE_TIME";
    FrequencyPeriod["MONTH"] = "MONTH";
    FrequencyPeriod["WEEK"] = "WEEK";
    FrequencyPeriod["DAY"] = "DAY";
    FrequencyPeriod["HOUR"] = "HOUR";
    FrequencyPeriod["MINUTE"] = "MINUTE";
})(FrequencyPeriod || (FrequencyPeriod = {}));
export var BillingType;
(function (BillingType) {
    BillingType["CPC"] = "CPC";
    BillingType["CPCV"] = "CPCV";
    BillingType["CPM"] = "CPM";
    BillingType["VCPM"] = "VCPM";
    BillingType["CPD"] = "CPD";
    BillingType["CPW"] = "CPW";
    BillingType["FIXED_PRICE"] = "FIXED_PRICE";
    BillingType["MAX_CPM"] = "MAX_CPM";
    BillingType["TRADING_CPM"] = "TRADING_CPM";
})(BillingType || (BillingType = {}));
export var DeliveryType;
(function (DeliveryType) {
    DeliveryType["EXCLUSIVE"] = "EXCLUSIVE";
    DeliveryType["GUARANTEED"] = "GUARANTEED";
    DeliveryType["STANDARD"] = "STANDARD";
    DeliveryType["NONE"] = "NONE";
})(DeliveryType || (DeliveryType = {}));
export var Device;
(function (Device) {
    Device["MULTIDEVICE"] = "MULTIDEVICE";
    Device["DESKTOP"] = "DESKTOP";
    Device["TABLET"] = "TABLET";
    Device["MOBILE"] = "MOBILE";
    Device["CTV"] = "CTV";
    Device["NO_DEVICE"] = "NO_DEVICE";
})(Device || (Device = {}));
export var MobileInventoryType;
(function (MobileInventoryType) {
    MobileInventoryType["ANY"] = "ANY";
    MobileInventoryType["WEB_ONLY"] = "WEB_ONLY";
    MobileInventoryType["APP_ONLY"] = "APP_ONLY";
})(MobileInventoryType || (MobileInventoryType = {}));
export var Media;
(function (Media) {
    Media["DISPLAY"] = "DISPLAY";
    Media["VIDEO"] = "VIDEO";
    Media["VIDEO_OUTSTREAM"] = "VIDEO_OUTSTREAM";
    Media["AUDIO"] = "AUDIO";
    Media["NATIVE"] = "NATIVE";
    Media["CLICK"] = "CLICK";
    Media["SOCIAL"] = "SOCIAL";
    Media["INTEGRATION"] = "INTEGRATION";
    Media["NEWSLETTER"] = "NEWSLETTER";
    Media["NO_MEDIA"] = "NO_MEDIA";
    Media["NOT_DECLARED"] = "NOT_DECLARED";
})(Media || (Media = {}));
export var Position;
(function (Position) {
    Position["TOP"] = "TOP";
    Position["RIGHT"] = "RIGHT";
    Position["FEED"] = "FEED";
    Position["CMS_TEASER"] = "CMS_TEASER";
    Position["VIDEO"] = "VIDEO";
    Position["BRANDING"] = "BRANDING";
    Position["OTHER"] = "OTHER";
    Position["NO_POSITION"] = "NO_POSITION";
})(Position || (Position = {}));
export var VideoPosition;
(function (VideoPosition) {
    VideoPosition["ANY"] = "ANY";
    VideoPosition["INSTREAM"] = "INSTREAM";
    VideoPosition["PRE_ROLL"] = "PRE_ROLL";
    VideoPosition["MID_ROLL"] = "MID_ROLL";
    VideoPosition["POST_ROLL"] = "POST_ROLL";
    VideoPosition["OUTSTREAM"] = "OUTSTREAM";
})(VideoPosition || (VideoPosition = {}));
export var AdPodPosition;
(function (AdPodPosition) {
    AdPodPosition["AD_POD_ANY"] = "AD_POD_ANY";
    AdPodPosition["AD_POD_FIRST"] = "AD_POD_FIRST";
    AdPodPosition["AD_POD_LAST"] = "AD_POD_LAST";
    AdPodPosition["BUMPER_INTRO"] = "BUMPER_INTRO";
    AdPodPosition["BUMPER_OUTRO"] = "BUMPER_OUTRO";
    AdPodPosition["BUMPER_BOTH"] = "BUMPER_BOTH";
})(AdPodPosition || (AdPodPosition = {}));
export var AdServerType;
(function (AdServerType) {
    AdServerType["XANDR"] = "XANDR";
    AdServerType["PASSENDO"] = "PASSENDO";
    AdServerType["FACEBOOK"] = "FACEBOOK";
    AdServerType["GAM"] = "GAM";
    AdServerType["NONE"] = "NONE";
    AdServerType["CRITEO"] = "CRITEO";
    AdServerType["MOENGAGE"] = "MOENGAGE";
})(AdServerType || (AdServerType = {}));
export var CampaignStage;
(function (CampaignStage) {
    CampaignStage["OFFERED"] = "OFFERED";
    CampaignStage["OFFER_DENIED"] = "OFFER_DENIED";
    CampaignStage["ALTERNATE_QUOTE"] = "ALTERNATE_QUOTE";
    CampaignStage["BOOKED"] = "BOOKED";
    CampaignStage["PERFORMANCE"] = "PERFORMANCE";
    CampaignStage["DRAFT"] = "DRAFT";
    CampaignStage["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    CampaignStage["ARCHIVED"] = "ARCHIVED";
    CampaignStage["PREPAYMENT"] = "PREPAYMENT";
})(CampaignStage || (CampaignStage = {}));
export var InvoiceDeliveryType;
(function (InvoiceDeliveryType) {
    InvoiceDeliveryType["POSTAL"] = "POSTAL";
    InvoiceDeliveryType["DIGITAL"] = "DIGITAL";
})(InvoiceDeliveryType || (InvoiceDeliveryType = {}));
export var PushMode;
(function (PushMode) {
    PushMode["AUTO"] = "AUTO";
    PushMode["MANUAL"] = "MANUAL";
    PushMode["NONE"] = "NONE";
})(PushMode || (PushMode = {}));
export var PublisherShareCalculationType;
(function (PublisherShareCalculationType) {
    PublisherShareCalculationType["PUBLISHER_SHARE_PERCENTAGE"] = "PUBLISHER_SHARE_PERCENTAGE";
    PublisherShareCalculationType["PUBLISHER_SHARE_FIXED"] = "PUBLISHER_SHARE_FIXED";
    PublisherShareCalculationType["MARKETER_SHARE_FIXED"] = "MARKETER_SHARE_FIXED";
})(PublisherShareCalculationType || (PublisherShareCalculationType = {}));
export var PayoutState;
(function (PayoutState) {
    PayoutState["OPEN"] = "OPEN";
    PayoutState["MISSING_PAYOUT_CONFIG"] = "MISSING_PAYOUT_CONFIG";
    PayoutState["APPROVED"] = "APPROVED";
    PayoutState["CANCELED"] = "CANCELED";
})(PayoutState || (PayoutState = {}));
export var Role;
(function (Role) {
    Role["ADVERTISER"] = "ADVERTISER";
    Role["AGENCY"] = "AGENCY";
    Role["BROKER"] = "BROKER";
    Role["OTHER"] = "OTHER";
    Role["PUBLISHER"] = "PUBLISHER";
})(Role || (Role = {}));
export var WebsiteGroupCopyRunStatus;
(function (WebsiteGroupCopyRunStatus) {
    WebsiteGroupCopyRunStatus["SUCCESS"] = "SUCCESS";
    WebsiteGroupCopyRunStatus["PARTIAL"] = "PARTIAL";
    WebsiteGroupCopyRunStatus["FAILED"] = "FAILED";
    WebsiteGroupCopyRunStatus["SKIPPED"] = "SKIPPED";
})(WebsiteGroupCopyRunStatus || (WebsiteGroupCopyRunStatus = {}));
export var FeeLineType;
(function (FeeLineType) {
    FeeLineType["SALES"] = "SALES";
    FeeLineType["TECH_FEE"] = "TECH_FEE";
})(FeeLineType || (FeeLineType = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["DE"] = "DE";
    LanguageCode["EN"] = "EN";
    LanguageCode["FR"] = "FR";
    LanguageCode["IT"] = "IT";
})(LanguageCode || (LanguageCode = {}));
export var Gender;
(function (Gender) {
    Gender["MALE"] = "MALE";
    Gender["FEMALE"] = "FEMALE";
})(Gender || (Gender = {}));
export var FormOfCommunication;
(function (FormOfCommunication) {
    FormOfCommunication["INFORMAL"] = "INFORMAL";
    FormOfCommunication["FORMAL"] = "FORMAL";
})(FormOfCommunication || (FormOfCommunication = {}));
export var MediaGroup;
(function (MediaGroup) {
    MediaGroup["BRANDING"] = "BRANDING";
    MediaGroup["DISPLAY"] = "DISPLAY";
    MediaGroup["VIDEO"] = "VIDEO";
    MediaGroup["NATIVE"] = "NATIVE";
    MediaGroup["NEWSLETTER"] = "NEWSLETTER";
    MediaGroup["INTEGRATION"] = "INTEGRATION";
    MediaGroup["OTHER"] = "OTHER";
})(MediaGroup || (MediaGroup = {}));
export var UpdateMode;
(function (UpdateMode) {
    UpdateMode["ALL"] = "ALL";
    UpdateMode["EMPTY_ONLY"] = "EMPTY_ONLY";
    UpdateMode["NONE"] = "NONE";
})(UpdateMode || (UpdateMode = {}));
export var SellSideCampaignPositionType;
(function (SellSideCampaignPositionType) {
    SellSideCampaignPositionType["CPC"] = "CPC";
    SellSideCampaignPositionType["FIXED_PRICE"] = "FIXED_PRICE";
    SellSideCampaignPositionType["IO"] = "IO";
    SellSideCampaignPositionType["PROGRAMMATIC"] = "PROGRAMMATIC";
})(SellSideCampaignPositionType || (SellSideCampaignPositionType = {}));
export var ReportingType;
(function (ReportingType) {
    ReportingType["WEEKLY"] = "WEEKLY";
    ReportingType["BY_END_DATE"] = "BY_END_DATE";
    ReportingType["FLIGHT_EXPIRATION"] = "FLIGHT_EXPIRATION";
    ReportingType["MANUAL"] = "MANUAL";
})(ReportingType || (ReportingType = {}));
export var ImportStatus;
(function (ImportStatus) {
    ImportStatus["PROCESSING"] = "PROCESSING";
    ImportStatus["SUCCESS"] = "SUCCESS";
    ImportStatus["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ImportStatus["IMPORT_ERROR"] = "IMPORT_ERROR";
})(ImportStatus || (ImportStatus = {}));
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["ALL"] = "ALL";
    CampaignStatus["OFFERED"] = "OFFERED";
    CampaignStatus["BOOKED"] = "BOOKED";
    CampaignStatus["PREPAYMENT"] = "PREPAYMENT";
    CampaignStatus["READY"] = "READY";
    CampaignStatus["RUNNING"] = "RUNNING";
    CampaignStatus["FINISHED"] = "FINISHED";
    CampaignStatus["ARCHIVED"] = "ARCHIVED";
    CampaignStatus["OFFER_DENIED"] = "OFFER_DENIED";
    CampaignStatus["APPROVALS"] = "APPROVALS";
    CampaignStatus["DRAFTS"] = "DRAFTS";
})(CampaignStatus || (CampaignStatus = {}));
export var VisibilityMode;
(function (VisibilityMode) {
    VisibilityMode["VISIBLE"] = "VISIBLE";
    VisibilityMode["HIDDEN"] = "HIDDEN";
    VisibilityMode["TRANSPARENT"] = "TRANSPARENT";
})(VisibilityMode || (VisibilityMode = {}));
export var AdServerState;
(function (AdServerState) {
    AdServerState["NONE"] = "NONE";
    AdServerState["ACTIVE"] = "ACTIVE";
    AdServerState["INACTIVE"] = "INACTIVE";
    AdServerState["NO_CREATIVES"] = "NO_CREATIVES";
    AdServerState["FINISHED"] = "FINISHED";
    AdServerState["DELETED"] = "DELETED";
})(AdServerState || (AdServerState = {}));
export var EventCategory;
(function (EventCategory) {
    EventCategory["NO_CATEGORY"] = "NO_CATEGORY";
    EventCategory["LANDING_PAGE"] = "LANDING_PAGE";
    EventCategory["ITEM_VIEW"] = "ITEM_VIEW";
    EventCategory["ADD_TO_CART"] = "ADD_TO_CART";
    EventCategory["INITIATE_CHECKOUT"] = "INITIATE_CHECKOUT";
    EventCategory["ADD_PAYMENT_INFO"] = "ADD_PAYMENT_INFO";
    EventCategory["PURCHASE"] = "PURCHASE";
    EventCategory["LEAD"] = "LEAD";
})(EventCategory || (EventCategory = {}));
export var IntervalType;
(function (IntervalType) {
    IntervalType["DAYS"] = "DAYS";
    IntervalType["HOURS"] = "HOURS";
    IntervalType["MINUTES"] = "MINUTES";
})(IntervalType || (IntervalType = {}));
export var PixelType;
(function (PixelType) {
    PixelType["IMAGE"] = "IMAGE";
    PixelType["JAVASCRIPT"] = "JAVASCRIPT";
})(PixelType || (PixelType = {}));
export var RepeatConversions;
(function (RepeatConversions) {
    RepeatConversions["ONE_CONVERSION_PER_USER"] = "ONE_CONVERSION_PER_USER";
    RepeatConversions["ALL_CONVERSIONS_PER_USER"] = "ALL_CONVERSIONS_PER_USER";
    RepeatConversions["ONE_CONVERSION_PER_USER_EVERY"] = "ONE_CONVERSION_PER_USER_EVERY";
})(RepeatConversions || (RepeatConversions = {}));
export var TriggerType;
(function (TriggerType) {
    TriggerType["HYBRID_VIEW_CLICK"] = "HYBRID_VIEW_CLICK";
    TriggerType["VIEW"] = "VIEW";
    TriggerType["CLICK"] = "CLICK";
})(TriggerType || (TriggerType = {}));
export var CustomPayoutIdRangeStatus;
(function (CustomPayoutIdRangeStatus) {
    CustomPayoutIdRangeStatus["ACTIVE"] = "ACTIVE";
    CustomPayoutIdRangeStatus["FULL"] = "FULL";
})(CustomPayoutIdRangeStatus || (CustomPayoutIdRangeStatus = {}));
export var SellerType;
(function (SellerType) {
    SellerType["PUBLISHER"] = "PUBLISHER";
    SellerType["INTERMEDIARY"] = "INTERMEDIARY";
    SellerType["BOTH"] = "BOTH";
})(SellerType || (SellerType = {}));
